import { render, staticRenderFns } from "./StockAdjustmentsActions.vue?vue&type=template&id=52db1802"
import script from "./StockAdjustmentsActions.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports